module.exports = __webpack_public_path__ + "img/docAppointRes_d.53177efd.png";